export default __webpack_public_path__ + "static/media/env5.fd96f371.hdr";